/* eslint-disable react/prop-types */
/* eslint-disable react/jsx-no-duplicate-props */
/* eslint-disable no-unused-expressions */
import React from "react";
import { Controller } from "react-hook-form";
import TextField from "@material-ui/core/TextField";
import FormControl from "@material-ui/core/FormControl";

const CustomInput = (props) => {
  const {
    label,
    name,
    type,
    className,
    disabled,
    multiline,
    rows,
    control,
    rule,
    error,
    inputProps,
    id,
    onValidate,
    styleTextField,
    styleFromHelperText,
    InputPropsParam,
    variant,
    helperText,
    onBlur,
    placeholder,
  } = props;

  const hasError = error && error[name];

  const styleHelperText = () => {
    if (styleFromHelperText) return styleFromHelperText;
    if (hasError) return { style: { margin: "0 0 0 5px", color: "#d61103" } };
    return { style: { margin: "0 0 0 5px", color: "#00000080" } };
  };

  return (
    <FormControl style={className} fullWidth>
      <Controller
        name={name}
        control={control}
        rules={rule}
        render={(controllerProps) => (
          <TextField
            label={label}
            id={id}
            size="small"
            type={type}
            fullWidth
            variant={variant || "outlined"}
            multiline={multiline}
            minRows={rows}
            value={controllerProps.value || ""}
            style={styleTextField}
            error={Boolean(hasError)}
            disabled={disabled}
            onBlur={onBlur}
            onChange={(e) => {
              controllerProps.onChange(e);
              onValidate && onValidate(e);
            }}
            inputProps={inputProps}
            InputProps={InputPropsParam}
            FormHelperTextProps={styleHelperText()}
            helperText={hasError ? hasError.message : helperText}
            placeholder={placeholder}
          />
        )}
      />
    </FormControl>
  );
};

export default CustomInput;
